export class SearchAllSectionRef {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sectionId",
            "baseName": "sectionId",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "SearchAllType",
            "format": ""
        },
        {
            "name": "provider",
            "baseName": "provider",
            "type": "Provider",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SearchAllSectionRef.attributeTypeMap;
    }
    constructor() {
    }
}
